import React, { useRef, useState } from 'react';
import axios, { post } from 'axios';
import IconButton from '../components/IconButton';

const UploadButton = React.forwardRef(({ beforeSend = null, callBack = null, small = false, icon, color, children = null, title = "", acaoApi, dados = {} }, ref) => {
    const token = localStorage.getItem('token');
    const internalRef = useRef(null);
    const fileRef = ref || internalRef;
    const [enviando, setEnviando] = useState(false);

    const fileUpload = file => {
        const tokenObj = token ? { 'Authorization': `Bearer ${token}` } : {};
        const url = process.env.REACT_APP_API_URL + '/' + acaoApi;
        const formData = new FormData();
        formData.append('file', file);
        for (const [key, value] of Object.entries(dados)) {
            formData.append(key, value);
        }
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
                ...tokenObj
            }
        };
        if (beforeSend) beforeSend();
        return post(url, formData, config);
    };

    const handleFileUpload = event => {
        const arquivo = event.target.files?.[0];
        if (!arquivo) return;
        // Trava reentrância: sem isso o usuário clica de novo achando que não
        // foi (não havia nenhum retorno visual) e o arquivo sobe duas vezes.
        if (enviando) return;

        setEnviando(true);
        fileUpload(arquivo).then((response) => {
            if (callBack) callBack(response.data.data);
        }).catch((error) => {
            if (callBack) callBack(error?.response?.data ?? { error: "Erro ao enviar arquivo" });
        }).finally(() => {
            setEnviando(false);
            // Permite selecionar o mesmo arquivo novamente em uma nova tentativa.
            event.target.value = "";
        });
    };

    return (
        <>
            <input
                ref={fileRef}
                onChange={handleFileUpload}
                type="file"
                style={{ display: "none" }}
                multiple={false}
            />
            <IconButton
                small={small}
                icon={enviando
                    ? <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                    : icon}
                color={color}
                title={enviando ? 'Enviando arquivo...' : title}
                style={enviando ? { cursor: 'wait', opacity: 0.75 } : null}
                onClick={() => { if (!enviando) fileRef.current.click(); }}
            >
                {/* Só troca o rótulo se o botão já tinha texto — os usos
                    icon-only continuam icon-only (spinner no lugar do ícone),
                    senão o botão cresce e quebra a coluna de ações. */}
                {enviando ? (children ? 'Enviando...' : null) : children}
            </IconButton>
        </>
    );
});

export default UploadButton;
